export function BrandMark() {
  return (
    <svg className="brand-logo" viewBox="0 0 64 64" aria-hidden="true">
      <rect width="64" height="64" rx="16" fill="var(--pacilo-navy-900)" />
      <circle cx="32" cy="24" r="10" fill="var(--pacilo-teal-500)" />
      <path d="M18 48c4.5-11 23.5-11 28 0" stroke="var(--pacilo-surface-teal)" strokeWidth="4" fill="none" strokeLinecap="round" />
      <circle cx="46" cy="18" r="4" fill="var(--pacilo-gold-500)" />
    </svg>
  );
}

export function WelcomeIllustration() {
  return (
    <svg className="hero-art" viewBox="0 0 360 260" role="img" aria-label="PACILO">
      <rect width="360" height="260" rx="28" fill="var(--pacilo-navy-900)" />
      <circle cx="86" cy="78" r="34" fill="var(--pacilo-lavender)" />
      <circle cx="268" cy="92" r="46" fill="var(--pacilo-teal-500)" />
      <circle cx="300" cy="48" r="14" fill="var(--pacilo-gold-500)" />
      <rect x="48" y="142" width="264" height="72" rx="24" fill="var(--pacilo-surface)" />
      <rect x="68" y="160" width="120" height="12" rx="6" fill="var(--pacilo-navy-900)" />
      <rect x="68" y="182" width="180" height="10" rx="5" fill="var(--pacilo-slate-600)" />
    </svg>
  );
}

export function AssessmentIllustration() {
  return (
    <svg className="spot-art" viewBox="0 0 160 120" aria-hidden="true">
      <rect width="160" height="120" rx="20" fill="var(--pacilo-surface-teal-soft)" />
      <rect x="22" y="24" width="116" height="14" rx="7" fill="var(--pacilo-navy-900)" />
      <rect x="22" y="50" width="88" height="10" rx="5" fill="var(--pacilo-slate-600)" />
      <rect x="22" y="72" width="70" height="10" rx="5" fill="var(--pacilo-teal-500)" />
    </svg>
  );
}

export function HomeHeroIllustration() {
  return (
    <svg className="home-hero-art" viewBox="0 0 280 220" aria-hidden="true">
      <circle cx="54" cy="178" r="28" fill="var(--pacilo-lavender)" />
      <circle cx="214" cy="46" r="40" fill="var(--pacilo-teal-500)" />
      <circle cx="246" cy="22" r="12" fill="var(--pacilo-gold-500)" />
      <rect x="36" y="48" width="176" height="132" rx="24" fill="var(--pacilo-surface)" />
      <rect x="56" y="72" width="88" height="12" rx="6" fill="var(--pacilo-navy-900)" />
      <rect x="56" y="98" width="128" height="10" rx="5" fill="var(--pacilo-slate-400)" />
      <rect x="56" y="120" width="104" height="10" rx="5" fill="var(--pacilo-teal-500)" />
      <rect x="56" y="148" width="72" height="14" rx="7" fill="var(--pacilo-surface-teal)" />
    </svg>
  );
}

export function EmptyIllustration() {
  return (
    <svg className="state-art" viewBox="0 0 160 120" aria-hidden="true">
      <rect width="160" height="120" rx="20" fill="var(--pacilo-surface-gold-warm)" />
      <circle cx="80" cy="52" r="18" fill="var(--pacilo-powder-blue)" />
      <rect x="44" y="82" width="72" height="10" rx="5" fill="var(--pacilo-border-strong)" />
    </svg>
  );
}

export function ErrorIllustration() {
  return (
    <svg className="state-art" viewBox="0 0 160 120" aria-hidden="true">
      <rect width="160" height="120" rx="20" fill="var(--pacilo-surface-warm)" />
      <circle cx="80" cy="56" r="22" fill="var(--pacilo-navy-900)" />
      <path d="M80 46v14" stroke="var(--pacilo-text-inverse)" strokeWidth="3" strokeLinecap="round" />
      <circle cx="80" cy="70" r="2" fill="var(--pacilo-text-inverse)" />
    </svg>
  );
}

export function DangerIllustration() {
  return (
    <svg className="danger-art" viewBox="0 0 64 64" aria-hidden="true">
      <rect width="64" height="64" rx="16" fill="var(--pacilo-surface-danger)" />
      <circle cx="32" cy="32" r="16" fill="var(--pacilo-color-danger)" />
      <path d="M32 22v12" stroke="var(--pacilo-text-inverse)" strokeWidth="3" strokeLinecap="round" />
      <circle cx="32" cy="42" r="2" fill="var(--pacilo-text-inverse)" />
    </svg>
  );
}
